module.exports = __webpack_public_path__ + "static/media/10WHEELS_LIFT.770a9c58.png";